import { allCountries, US } from 'country-region-data'
import { ICountryWorld, IDataCountriesReducer, IDealersAndAgentsReducer, IDealerWorld } from 'src/interface'

export const isToday = (date: Date) => {
  const today = new Date()
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  )
}

/**
 * Converts a string to a slug by replacing spaces with "-" and removing special characters.
 *
 * @param text The input string to be converted.
 * @returns The formatted slug.
 */
export const convertToSlug = (text: string) => {
  return text
    .toLowerCase()
    .replace(/[^\w ]+/g, '')
    .replace(/ +/g, '-')
}

/**
 * Gets the country name searching by country code.
 *
 * @param countryCode The country code to search by.
 * @returns The complete name.
 */
export const getCountryName = (countryCode: string) =>
  allCountries.find((countryToFind) => countryToFind[1] === countryCode.toUpperCase())?.[0] || countryCode

/**
 * Gets the state name searching by state code.
 *
 * @param stateCode The state code to search by.
 * @returns The complete name.
 */
export const getStateName = (stateCode: string) => {
  if (stateCode === 'none') return undefined
  return US[2].find((stateToFind) => stateToFind[1] === stateCode)?.[0] || stateCode
}

/**
 * Returns a list of international dealers filtered by the given country code.
 * Optionally excludes the dealer 'Chris Burger' from the results.
 *
 * @param countryCode - The country code used to filter dealers.
 * @param dealersReducer - Reducer containing the full list of dealers.
 * @param countriesReducer - Reducer containing country information.
 * @param includeChris - If false, excludes 'Chris Burger' from the list (default: false).
 * @returns A filtered array of international dealers matching the specified criteria.
 */
export const getInternationalDealers = (
  countryCode: string,
  dealersReducer: IDealersAndAgentsReducer,
  countriesReducer: IDataCountriesReducer,
  includeChris: boolean = false
) => {
  const dealers = dealersReducer.dealersAgents.dealers
  const selectedCountry = countriesReducer.countries.find(
    (country: ICountryWorld) => country.COUNTRYCODE === countryCode.toLowerCase()
  )
  const filteredDealers = dealers.filter((element: IDealerWorld) => {
    return (
      (element.Country === null || element.Country === selectedCountry?.DISPLAY) &&
      (includeChris || element.Contact !== 'Chris Burger')
    )
  })
  return filteredDealers
}

/**
 * Returns a list of domestic dealers filtered by the given state code.
 *
 * @param stateSelected - The state code used to filter dealers.
 * @param dataContactReducer - Reducer containing the full list of dealers.
 * @returns A filtered array of domestic dealers matching the specified criteria.
 */
export const getDomesticDealers = (stateSelected: string, dataContactReducer: IDealersAndAgentsReducer) => {
  const dealersByState = dataContactReducer.dealersAgents.domestic.filter((item) => {
    return item.states.includes(stateSelected)
  })
  const domesticDealers = dealersByState.map((dealer) => {
    return {
      Email: dealer.email,
      Contact: dealer.name,
      PhoneNumber: dealer.tollFreePhone,
      ProductsList: []
    }
  })
  return domesticDealers
}
